import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=b60d4a14&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60d4a14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b60d4a14')) {
      api.createRecord('b60d4a14', component.options)
    } else {
      api.reload('b60d4a14', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=b60d4a14&scoped=true&", function () {
      api.rerender('b60d4a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2259AD7csNT6b/JS/comp/Voucher-Unit.vue"
export default component.exports